<template>
  <div style="text-align: center;width: 700px;">
    <img src="/assets/images/shouquan.jpg" />
    <p style="color: #714a38;position: absolute;left: 285px;top: 395px;border: 0px;z-index: 999;font-weight: bold;font-size: 17px;">{{ data.real_name }}</p>
    <p style="color: #714a38;position: absolute;left: 321px;top: 433px;border: 0px;z-index: 999;font-weight: bold;font-size: 17px;">{{ data.level_name }}</p>
    <p style="color: #714a38;position: absolute;left: 302px;top: 469px;border: 0px;z-index: 999;font-weight: bold;font-size: 17px;">{{ data.wechat }}</p>
    <p style="color: #714a38;position: absolute;left: 300px;top: 508px;border: 0px;z-index: 999;font-weight: bold;font-size: 17px;">{{ data.username }}</p>
    <p style="color: #714a38;position: absolute;left: 399px;top: 754px;border: 0px;z-index: 999;font-weight: bold;font-size: 17px;">{{ data.auth_begin_time }}</p>
  </div>
</template>

<script>
export default {
  name: 'UserDetailAuth',
  props: {
    data: Object
  },
  computed: {}
};
</script>

<style></style>
